export const CURBSIDE_INFO_KEY = 'curbside-info';
